export enum EventPageContentElementType {
  HOST_AND_SPEAKER = 'host-and-speaker',
  SCHEDULE = 'schedule',
  SPONSOR = 'sponsor',
}

export const eventPageContentElementTypes = Object.values(
  EventPageContentElementType,
) as string[];

export interface EventPageContentBaseElementConfig {
  shouldShowOnPage: boolean;
}

export interface EventPageContentHostAndSpeakerElementConfig {
  shouldHostShowOnPage: boolean;
  shouldSpeakerShowOnPage: boolean;
}

type EventPageContentHostAndSpeakerElement = {
  id: string;
  type: EventPageContentElementType.HOST_AND_SPEAKER;
  config: Partial<EventPageContentHostAndSpeakerElementConfig>;
};

type EventPageContentScheduleElement = {
  id: string;
  type: EventPageContentElementType.SCHEDULE;
  config: Partial<EventPageContentBaseElementConfig>;
};

type EventPageContentSponsorElement = {
  id: string;
  type: EventPageContentElementType.SPONSOR;
  config: Partial<EventPageContentBaseElementConfig>;
};

export type EventPageContentElement =
  | EventPageContentHostAndSpeakerElement
  | EventPageContentScheduleElement
  | EventPageContentSponsorElement;

export interface EventPageContentConfig {
  id: string;
  elements: EventPageContentElement[];
}

export interface GetEventPageContentConfigResponse {
  elements: EventPageContentElement[];
}
